import { useEffect, useRef, useState } from 'react';

const useElementWidth = () => {
  const elementRef = useRef();
  const [width, setWidth] = useState();

  useEffect(() => {
    setWidth(elementRef.current.clientWidth);
  }, []); // Empty array ensures that effect is only run on mount and unmount.

  return [elementRef, width];
};

export default useElementWidth;
